import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";

const Get_Load_By_Id = gql`
  query loadByID($ID: ID) {
    loadByID(ID: $ID) {
      _id
      Unique_Id
      UserId {
        _id
        FullName
      }
      AccountData {
        Business_Name
        Proprietor_Name
        Mobile_Number
        Unique_Id
      }
      Load_Post_Type
      Auction_Date
      Auction_Time
      Dangerous_Goods
      Exact_Content
      Expected_Price
      From_City
      Load_Live_Duration
      Load_Manager {
        _id
        FullName
      }
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Town
      Loading_Address_Line_1
      Loading_Address_Line_2
      Material_Category
      Material_Dimension
      Material_Dimension_In
      Material_Insurence
      Material_Image
      Material_Image_2
      Material_Image_3
      No_Of_Vehicels_Required
      No_Of_Vehicels_Loading_Completed
      Notes
      Over_Dimension_Cargo
      Payment_Type {
        _id
        Name
      }
      Rate_per
      Target_Price
      To_City
      Total_Weight
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Town
      Unloading_Address_Line_1
      Unloading_Address_Line_2
      Vehicle_Category {
        _id
        Search_Value
      }
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      Private_Group_ID {
        _id
      }
      Private_Contact_ID {
        _id
      }
      Post_To_Private_Network
      Post_To_EMT_Load_Board
      Is_Live
      Is_Auction_Started
      Is_Archive
      createdAt
      updatedAt
    }
  }
`;

const LoadDetails = ({ LoadId, Type }) => {
  let { data, loading } = useQuery(Get_Load_By_Id, {
    variables: { ID: LoadId },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [loadData, setLoadData] = useState<any>({});

  useEffect(() => {
    if (data) {
      setLoadData(data.loadByID[0]);
    }
  }, [data]);

  let arr = [
    [
      {
        name: "From-To :",
        Value: `${loadData?.From_City ? loadData?.From_City : ""} - ${
          loadData?.To_City ? loadData?.To_City : loading ? "Loading..." : ""
        }`,
      },
      {
        name: "Loading Point :",
        Value: `${loadData?.Loading_Area ? loadData?.Loading_Area : loading ? "Loading..." : ""}, ${
          loadData?.Loading_City ? loadData?.Loading_City : ""
        }, ${loadData?.Loading_State ? loadData?.Loading_State : ""}, ${
          loadData?.Loading_Pincode ? loadData?.Loading_Pincode : ""
        }`,
      },
      {
        name: "Unloading Point :",
        Value: `${loadData?.Unloading_Area ? loadData?.Unloading_Area : loading ? "Loading..." : ""}, ${
          loadData?.Unloading_City ? loadData?.Unloading_City : ""
        }, ${loadData?.Unloading_State ? loadData?.Unloading_State : ""}, ${
          loadData?.Loading_Pincode ? loadData?.Unloading_Pincode : ""
        }`,
      },
      {
        name: "Loading :",
        Value: `${loadData?.Loading_Date ? IsoToDateTime(loadData?.Loading_Date) : loading ? "Loading..." : ""}`,
      },
      {
        name: "Payment Type :",
        Value: `${loadData?.Payment_Type ? loadData?.Payment_Type?.Name : loading ? "Loading..." : ""}`,
      },
      {
        name: "Load Post Type :",
        Value: `${loadData?.Load_Post_Type ? loadData?.Load_Post_Type : loading ? "Loading..." : ""}`,
      },
      {
        name: "Load Live Duration :",
        Value: `${loadData?.Load_Live_Duration ? loadData?.Load_Live_Duration : loading ? "Loading..." : ""}`,
      },
      {
        name: "Load Target Price :",
        Value: `${loadData?.Target_Price ? loadData?.Target_Price : loading ? "Loading..." : ""}`,
      },
      { name: "Load Rate Per :", Value: `${loadData?.Rate_per ? loadData?.Rate_per : loading ? "Loading..." : ""}` },
    ],
    [
      {
        name: "Vehicle No :",
        Value: `${loadData?.No_Of_Vehicels_Required ? loadData?.No_Of_Vehicels_Required : loading ? "Loading..." : ""}`,
      },
      { name: "Vehicle Type :", Value: `` },
    ],
    [
      {
        name: "Material Weight :",
        Value: `${loadData?.Total_Weight ? `${loadData?.Total_Weight} MT` : loading ? "Loading..." : ""}`,
      },
      {
        name: "Material Category :",
        Value: `${loadData?.Material_Category ? loadData?.Material_Category : loading ? "Loading..." : ""}`,
      },
      {
        name: "Material Insurance :",
        Value: `${loadData?.Material_Insurence ? loadData?.Material_Insurence : loading ? "Loading..." : ""}`,
      },
      {
        name: "Content :",
        Value: `${loadData?.Exact_Content ? loadData?.Exact_Content : loading ? "Loading..." : ""}`,
      },
    ],
    [
      {
        name: "Unique Id :",
        Value: loadData?.AccountData?.Unique_Id || "",
      },
      {
        name: "Business Name :",
        Value: `${loadData?.AccountData ? `${loadData?.AccountData?.Business_Name}` : loading ? "Loading..." : ""}`,
      },
      {
        name: "Proprietor Name :",
        Value: `${loadData?.AccountData ? loadData?.AccountData?.Proprietor_Name : loading ? "Loading..." : ""}`,
      },
      {
        name: "Mobile Number :",
        Value: `${
          loadData?.AccountData?.Mobile_Number
            ? loadData?.AccountData?.Mobile_Number
            : loading
            ? "Loading..."
            : "Not Available"
        }`,
      },
    ],
  ];

  return (
    <>
      {Type === "Bidding" && (
        <div className="loadDetails">
          <div>
            <div>
              <p className="detailsHeading">Load Details</p>
              {arr[0].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
            <div>
              <p className="detailsHeading">Notes :</p>
              <div>
                <p>{loadData?.Notes}</p>
              </div>
            </div>
            {/* <div>
              <p className="detailsHeading">Bid Notes :</p>
              <div>
                <p>This is Bid Note</p>
              </div>
            </div> */}
            <div>
              <p className="detailsHeading">LP Details :</p>
              {arr[3].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <div>
              <p className="detailsHeading">Materials Details</p>
              {arr[2].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
            <div>
              <p className="detailsHeading">Vehicle Required</p>
              {/* {arr[1].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })} */}
              <div>
                <p>Vehicle No :</p>
                <p>{loadData?.No_Of_Vehicels_Required ? loadData?.No_Of_Vehicels_Required : ""}</p>
              </div>
              <div>
                <p>Vehicle Type</p>
                <p className="vehicleDetailsHeading">
                  {/* Vehicle Type :{"  "}{" "} */}
                  {/* <span className="VTNumber" onClick={() => setViewT(!viewT)}>
                    {" "}
                    {viewT ? "view less" : "view more"} */}
                  {/* </span> */}
                  {loadData?.VehicleCategoryGroupData &&
                    loadData?.VehicleCategoryGroupData?.map((item, index) => (
                      <div className="VTData">
                        <div>
                          {`${index + 1}. ${item.VehicleType} -`}
                          {index < loadData.VehicleCategoryGroupData.length - 1 ? "\n" : ""}{" "}
                        </div>
                        <div>
                          {item?.VehicleCategory?.map((category, index) => (
                            <div>
                              {category.Name}
                              {index < item.VehicleCategory.length - 1 ? "," : ""}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  {/* <br></br>({weightcategory && weightcategory.join(", ")}) */}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {(Type === "ResultLP" || Type === "SearchSP" || Type === "BidsSP") && (
        <div className="loadDetails">
          <div>
            <div>
              <p className="detailsHeading">Load Details</p>
              {arr[0].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <div>
              <p className="detailsHeading">Materials Details</p>
              {arr[2].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
            <div>
              <p className="detailsHeading">Notes :</p>
              <div>
                <p>{loadData?.Notes}</p>
              </div>
            </div>
            <div>
              <p className="detailsHeading">LP Details :</p>
              {arr[3].map((e) => {
                return (
                  <div>
                    <p>{e.name}</p>
                    <p>{e.Value}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <div>
              <p className="detailsHeading">Vehicle Required</p>
              <div>
                <p>Vehicle No :</p>
                <p>{loadData?.No_Of_Vehicels_Required ? loadData?.No_Of_Vehicels_Required : ""}</p>
              </div>
              <div>
                <p>Vehicle Type</p>
                <p className="vehicleDetailsHeading">
                  {/* Vehicle Type :{"  "}{" "} */}
                  {/* <span className="VTNumber" onClick={() => setViewT(!viewT)}>
                    {" "}
                    {viewT ? "view less" : "view more"} */}
                  {/* </span> */}
                  {loadData?.VehicleCategoryGroupData &&
                    loadData.VehicleCategoryGroupData?.map((item, index) => (
                      <div className="VTData">
                        <div>
                          {`${index + 1}. ${item.VehicleType} -`}
                          {index < loadData.VehicleCategoryGroupData.length - 1 ? "\n" : ""}{" "}
                        </div>
                        <div>
                          {item?.VehicleCategory?.map((category, index) => (
                            <div>
                              {category.Name}
                              {index < item.VehicleCategory.length - 1 ? "," : ""}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  {/* <br></br>({weightcategory && weightcategory.join(", ")}) */}
                </p>
              </div>
            </div>
            {/* <div>
              <p className="detailsHeading">Bid Notes :</p>
              <div>
                <p>This is Bid Note</p>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default LoadDetails;
